import React from 'react';
import '../styles/FailurePage.css';

const FailurePage = ({
    title = 'Oops',
    message = 'Something went wrong. Please try again later.',
    actionLabel = 'Retry',
    onAction,
    secondaryText = ''
}) => {
    return (
        <div
            className="failure-container"
            data-toast-suppress="true"
        >
            <section className="failure-content-panel content-box">
                <div className="failure-badge">Page unavailable</div>
                <h2 className="failure-title">{title}</h2>
                <p className="failure-message">{message}</p>
                {secondaryText ? (
                    <p className="failure-secondary">{secondaryText}</p>
                ) : null}
                {onAction ? (
                    <button type="button" className="failure-button" onClick={onAction}>
                        {actionLabel}
                    </button>
                ) : null}
            </section>
        </div>
    );
};

export default FailurePage;